import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme?.spacing?.small};

  text-align: center;
  font-size: ${({ theme }) => theme.fontSize.default};

  padding: ${({ theme }) => theme?.spacing?.large};
  background: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.radius.small};

  .title {
    font-weight: bold;
  }
`;

export const FeatureUnavailable = () => {
  return (
    <StyledContainer>
      <h2 className="title">Feature Unavailable.</h2>
      <p>
        This feature is not enabled. <br /> Please contact your administrator.
      </p>
    </StyledContainer>
  );
};
